import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { env } from "../../../../../env";
import axiosInstance from "../../../../globalInspector/axiosInstance";
import CryptoJS from "crypto-js";
import CommonToast from "../../../../../components/_utils/CommonToast";
import ICONS from "../../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

function encryptPassword(password, key) {
  const encryptedPassword = CryptoJS.HmacSHA256(password, key).toString();
  return encryptedPassword;
}

export const getUsers = createAsyncThunk(
  "getUsers",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      search_string,
      account_tags,
      grade,
      active_status,
      sort_by,
    } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/users`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no: page_no,
          page_size: page_size,
          search_string: search_string,
          account_tags: account_tags,
          active_status: active_status,
          grade: grade,
          sort_by: sort_by,
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

export const getSpecificUser = createAsyncThunk(
  "getSpecificUser",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/users/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      // Show toast

      return rejectWithValue(undefined);
    }
  },
);

export const AddUserTag = createAsyncThunk(
  "AddUserTag",
  async ({ user_id, tags }, { rejectWithValue }) => {
    const data = {
      user_id: user_id,
      account_tags: tags,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/users/add_tag`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response.data.errors?.base) {
        CommonToast({
          text: error.response.data.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        CommonToast({
          text: error.response.data.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const RemoveUserTag = createAsyncThunk(
  "RemoveUserTag",
  async ({ user_id, tags }, { rejectWithValue }) => {
    const data = {
      user_id: user_id,
      account_tags: tags,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/users/remove_tag`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error.response.data.errors?.base) {
        CommonToast({
          text: error.response.data.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      } else {
        CommonToast({
          text: error.response.data.errors?.user_unauthorized[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const deleteUser = createAsyncThunk(
  "deleteUser",
  async ({ user_id, active_status }, { rejectWithValue }) => {
    const data = {
      active_status,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/users/${user_id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const resetPasswordCommunicate = createAsyncThunk(
  "resetPasswordCommunicate",
  async ({ user_id, entity_id }, { rejectWithValue }) => {
    const data = {
      user_id: user_id,
      entity_id: entity_id,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/users/reset_password_communicate`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getAllRoles = createAsyncThunk(
  "getAllRoles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/roles`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(error);
    }
  },
);

export const createUser = createAsyncThunk(
  "createUser",
  async ({ userPayload }, { rejectWithValue }) => {
    const {
      alias,
      contact_no,
      email_id,
      entity_Id,
      grade,
      password,
      user_id,
      account_name,
    } = userPayload;

    const key = env.REACT_APP_ENCRYPTION_KEY;

    const encryptedPassword = encryptPassword(password, key);

    const data = {
      email: email_id,
      grade: grade,
      alias_name: alias,
      mob_no: contact_no,
      entity_id: entity_Id,
      first_name: account_name,
      auth_key: encryptedPassword,
      identifier: user_id,
    };

    try {
      const response = await axiosInstance.post(`${baseUrl}/users`, data, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });

      return response.data;
    } catch (error) {
      const apiError = error?.response?.data;
      return rejectWithValue(apiError);
    }
  },
);

export const assignRole = createAsyncThunk(
  "assignRole",
  async ({ newRoles, id }, { rejectWithValue }) => {
    let roleId = newRoles?.map((val) => {
      return { role_id: val?.role_id };
    });
    const data = {
      user_roles_attributes: roleId,
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/users/${id}/add_roles`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      const apiError = error?.response?.data;
      return rejectWithValue(apiError);
    }
  },
);

export const removeRole = createAsyncThunk(
  "removeRole",
  async ({ role_id, id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        `${baseUrl}/users/${id}/remove_role`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          data: {
            role_id,
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const EditUser = createAsyncThunk(
  "users/editUser",
  async (values, { rejectWithValue }) => {
    try {
      const { id, first_name, last_name, mob_no, email, grade, alias_name } =
        values;

      const response = await axiosInstance.put(
        `${baseUrl}/users/${id}`,
        {
          first_name,
          last_name,
          mob_no,
          email,
          grade,
          alias_name,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Failed to update user");
    }
  },
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    isLoading: false,
    users: null,
    isError: false,
    userStoredPage: 1,
    userStoredPagesize: 50,
    addUserTagsLoading: true,
    addUserTagsData: [],
    addUserTagsError: false,

    removeUserTagsLoading: false,
    removeUserTagsData: [],
    removeUserTagsError: null,

    specificUserData: null,
    specificUserLoading: null,
    specificUserError: null,

    deleteUserStatus: null,
    deleteUserLoading: null,
    deleteUserError: null,

    allRolesData: null,
    allRolesLoading: null,
    allRolesError: null,

    createUserData: null,
    createUserLoading: null,
    createUserError: null,

    assignRoleData: null,
    assignRoleLoading: null,
    assignRoleError: null,
    editUserLoading: false,
    editUserSuccess: false,
    editUserError: null,
  },
  reducers: {
    resetUserpage: (state) => {
      state.userStoredPage = 1;
    },
    setUserStoredPage: (state, action) => {
      state.userStoredPage = action.payload;
    },
    resetUserpagesize: (state) => {
      state.userStoredPagesize = 50;
    },
    setUserStoredPagesize: (state, action) => {
      state.userStoredPagesize = action.payload;
    },
    resetEditUserState: (state) => {
      state.editUserLoading = false;
      state.editUserSuccess = false;
      state.editUserError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(AddUserTag.pending, (state) => {
      state.addUserTagsLoading = true;
      state.addUserTagsError = null;
    });
    builder.addCase(AddUserTag.fulfilled, (state, action) => {
      state.addUserTagsLoading = false;
      state.addUserTagsData = action.payload;
      state.addUserTagsError = null;
    });
    builder.addCase(AddUserTag.rejected, (state, action) => {
      state.addUserTagsLoading = false;
      state.addUserTagsData = null;
      state.addUserTagsError = action.payload;
    });

    builder.addCase(RemoveUserTag.pending, (state) => {
      state.removeUserTagsLoading = true;
      state.removeUserTagsError = null;
    });
    builder.addCase(RemoveUserTag.fulfilled, (state, action) => {
      state.removeUserTagsLoading = false;
      state.removeUserTagsData = action.payload;
      state.removeUserTagsError = null;
    });
    builder.addCase(RemoveUserTag.rejected, (state, action) => {
      state.removeUserTagsLoading = false;
      state.removeUserTagsData = null;
      state.removeUserTagsError = action.payload;
    });

    builder.addCase(getUsers.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(getUsers.fulfilled, (state, action) => {
      if (action?.payload?.available_tags) {
        sessionStorage.setItem(
          "UserAvailableTags",
          JSON.stringify(action?.payload?.available_tags || []),
        );
      }
      state.isLoading = false;
      state.users = action.payload;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
    });
    builder.addCase(getSpecificUser.pending, (state, action) => {
      state.specificUserLoading = true;
    });
    builder.addCase(getSpecificUser.fulfilled, (state, action) => {
      state.specificUserLoading = false;
      state.specificUserData = action.payload;
    });
    builder.addCase(getSpecificUser.rejected, (state, action) => {
      state.specificUserLoading = false;
      state.specificUserError = true;
      state.specificUserData = null;
    });

    builder.addCase(deleteUser.pending, (state, action) => {
      state.deleteUserLoading = true;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.deleteUserLoading = false;
      state.deleteUserStatus = action.payload;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.deleteUserError = true;
      state.deleteUserStatus = null;
    });

    builder.addCase(getAllRoles.pending, (state, action) => {
      state.allRolesLoading = true;
    });
    builder.addCase(getAllRoles.fulfilled, (state, action) => {
      state.allRolesLoading = false;
      state.allRolesData = action.payload;
    });
    builder.addCase(getAllRoles.rejected, (state, action) => {
      state.allRolesLoading = false;
      state.allRolesError = true;
      state.allRolesData = null;
    });

    builder.addCase(createUser.pending, (state) => {
      state.createUserLoading = true;
    });
    builder.addCase(createUser.fulfilled, (state, action) => {
      state.createUserLoading = false;
      state.createUserData = action.payload;
    });
    builder.addCase(createUser.rejected, (state) => {
      state.createUserLoading = false;
      state.createUserError = true;
      state.createUserData = null;
    });

    builder.addCase(assignRole.pending, (state) => {
      state.assignRoleLoading = true;
    });
    builder.addCase(assignRole.fulfilled, (state, action) => {
      state.assignRoleLoading = false;
      state.assignRoleData = action.payload;
    });
    builder.addCase(assignRole.rejected, (state) => {
      state.assignRoleLoading = false;
      state.assignRoleError = true;
      state.assignRoleData = null;
    });
    builder.addCase(EditUser.pending, (state) => {
      state.editUserLoading = true;
      state.editUserSuccess = false;
    });
    builder.addCase(EditUser.fulfilled, (state) => {
      state.editUserLoading = false;
      state.editUserSuccess = true;
    });
    builder.addCase(EditUser.rejected, (state, action) => {
      state.editUserLoading = false;
      state.editUserError = action.payload;
    });
  },
});

export const {
  setUserStoredPage,
  resetUserpage,
  setUserStoredPagesize,
  resetUserpagesize,
  resetEditUserState,
} = usersSlice.actions;
export default usersSlice.reducer;
